import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { TPopupDefaultActions } from '../../../../../../../../shared/components/popup/services/popup.service.ts';
import { FormProvider, useForm } from 'react-hook-form';
import { createValidationSchema } from './newClient.schema.ts';
import { yupResolver } from '@hookform/resolvers/yup';
import { Content } from './content.popup.tsx';

const validationSchema = createValidationSchema();
export class NewClientPopup extends Popup<INewClientPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const { t } = useTranslation();
      const formMethods = useForm<IFormData>({
        defaultValues: {
          email: '',
          name: '',
          customerId: null,
          note: '',
          orderAddNewItem: false,
          orderNoDelivery: false,
          orderShowPrice: false,
          standardOrderEdit: false,
        },
        resolver: yupResolver(validationSchema),
      });
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 500, minWidth: 500, width: '100%' },
          '& > div > div > div': { padding: 20 },
        }));
      }, []);

      return (
        <FormProvider {...formMethods}>
          <SWrapper stream={stream} popupTitle={t('settings.invite_new_client')}>
            <Content {...{ stream }} />
          </SWrapper>
        </FormProvider>
      );
    };
  }
}

export interface IFormData {
  email: string;
  name: string;
  customerId: string | number | null;
  note: string;
  orderAddNewItem: boolean;
  orderNoDelivery: boolean;
  orderShowPrice: boolean;
  standardOrderEdit: boolean;
}
export interface INewClientPopup {
  action: TPopupDefaultActions;
}
